import { render, staticRenderFns } from "./AttachmentLightbox.vue?vue&type=template&id=41e2ea7a&scoped=true"
import script from "./AttachmentLightbox.vue?vue&type=script&lang=js"
export * from "./AttachmentLightbox.vue?vue&type=script&lang=js"
import style0 from "./AttachmentLightbox.vue?vue&type=style&index=0&id=41e2ea7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e2ea7a",
  null
  
)

export default component.exports